// Fase 4 · Monta los hubs de tiempo real del TPV según el interruptor V2.
// Componentes (no hooks condicionales): el layout renderiza uno u otro.
import React from "react";
import useTpvRealtime from "./useTpvRealtime";
import useHubMesas from "src/utils/hubs/hubMesas";
import useHubBooking from "src/utils/hubs/HubBooking";
import { usePedidoSessionHub, usePedidoUserHub } from "src/utils/hubs/PedidoHub";
import { useProductUserHub } from "src/utils/hubs/HubProductoSession";
import { isRealtimeV2Enabled } from "./realtimeFlag";
import useTpvResume from "./useTpvResume";

/** V2: una sola conexión `/hub/tpv`. */
export function TpvRealtimeV2() {
  useTpvRealtime();
  return null;
}

/** Legacy: mesas, reservas, pedidos (restaurante + sesión) y productos. */
export function LegacyTpvHubs({ withProducts = true }) {
  useHubMesas();
  useHubBooking();
  usePedidoUserHub();
  usePedidoSessionHub();
  return withProducts ? <LegacyProductHub /> : null;
}

function LegacyProductHub() {
  useProductUserHub();
  return null;
}

// El interruptor se lee una vez por carga de página (el kill-switch de
// localStorage requiere recargar).
const V2 = isRealtimeV2Enabled();

/**
 * Vuelta de segundo plano / red / hub (resumeOrchestrator + tpvResume): igual
 * en V2 y en legacy. El aviso de tiempo real ya no es un banner: va en la
 * pastilla de estado (TpvStatusPill, en el TopBar o en la carta).
 */
function TpvResume() {
  useTpvResume();
  return null;
}

export default function TpvRealtimeHubs({ withProducts = true }) {
  return (
    <>
      {V2 ? <TpvRealtimeV2 /> : <LegacyTpvHubs withProducts={withProducts} />}
      <TpvResume />
    </>
  );
}
